import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-codigo',
  templateUrl: './text-codigo.component.html',
  styleUrls: ['./text-codigo.component.scss'],
  viewProviders: [ ParentFormGroup ],
})
export class TextCodigoComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
